export default __webpack_public_path__ + "static/champion-htf-bantamweight-webfont-9c5817dc4891e08a3065e87f75901101.woff";